import {AxiosRequestConfig, AxiosResponse} from 'axios';
import {EntityUser} from '../backend/responses/entity-user';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityUsersRepository {
  // Singleton Instance
  private static _instance: EntityUsersRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityUsersRepository {
    if (!this._instance) {
      this._instance = new EntityUsersRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityUsersRepository');
  }

  // Get an affiliation between an Entity and a User
  public async getById(
    entityId: string,
    userId: string,
    options?: AxiosRequestConfig
  ): Promise<EntityUser> {
    let url: string = `/entities/${entityId}/users/${userId}`;

    const result: AxiosResponse<EntityUser> = await BackendApiManager.instance.get<EntityUser>(
      url,
      options
    );

    return result.data;
  }
}
